module.exports = __webpack_public_path__ + "static/img/third9.0e6a479a.png";